import ApiService from '../../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

const forEach = require('lodash/forEach');

export default {
    namespaced: true,
    state() {
        return {
            paginate: {},
            categories: [],
            refreshAccess: false,
        }
    },
    getters: {
        news: (state) => {
            return state.paginate.hasOwnProperty('data')
                ? state.paginate.data
                : [];
        },
        paginate: (state) => {
            return state.paginate;
        },
        categories: (state) => {
            return state.categories;
        },
        refreshAccess: (state) => {
            return state.refreshAccess;
        }
    },
    mutations: {
        setRefreshAccess(state, value) {
            state.refreshAccess = value;
        },
        setNewsPaginate(state, value) {
            window.Vue.set(state, 'paginate', value);
        },
        updateNews(state, news) {
            let newsList = state.paginate.data ?? [];

            forEach(newsList, (item, key) => {
                if (item.id === news.id) {
                    window.Vue.set(state.paginate.data, key, news);
                }
            });
        },
        setCategories(state, value) {
            window.Vue.set(state, 'categories', value);
        }
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/admin/news', payload)
                    .then((response) => {
                        resolve(response);
                        commit('setNewsPaginate', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        changePublish({state, commit, getters}, article) {
            return new Promise((resolve, reject) => {
                ApiService.post('/admin/news/toggle-publish', {article_id: article.id})
                    .then((response) => {
                        resolve(response);
                        commit('updateNews', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        deleteArticle({state, commit, getters}, article){
            return new Promise((resolve, reject) => {
                ApiService.delete('/admin/news/' + article.id)
                    .then((response) => {
                        resolve(response);
                        commit('setRefreshAccess', true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        incAmountViews({state, commit, getters}, id) {
            return new Promise((resolve, reject) => {
                ApiService.get('/news/inc-views/' + id)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getCategories({state, commit, getters}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/admin/news-category')
                    .then((response) => {
                        resolve(response);
                        commit('setCategories', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getArticlesByCategory({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/news', payload)
                    .then((response) => {
                        resolve(response);
                        commit('setNewsPaginate', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    }
};
